export default __webpack_public_path__ + "static/media/user-circle.8c786b57.svg";